const translations = {
    'By registering you agree to our': {
        en: 'By registering you agree to our',
        fr: 'En créant un compte, vous acceptez nos',
        nl: 'Door u te registreren, gaat u akkoord met de',
    },
    'T&C': {
        en: 'Terms and conditions',
        fr: 'Conditions d\'Utilisation',
        nl: 'Gebruiksvoorwaarden',
    },
    'of Arteia': {
        en: 'of Arteia',
        fr: 'd\'Arteïa',
        nl: 'van Arteïa',
    },
    'Already have account': {
        en: 'I already have an account',
        fr: 'Vous êtes déjà membre ? Connectez-vous',
        nl: 'Reeds lid? Aanmelden',
    },
    'My collection': {
        en: 'My collection',
        fr: 'Accéder à ma collection',
        nl: 'Mijn collectie raadplegen',
    },
    'Create collection': {
        en: 'Create the access to my collection',
        fr: 'Créer l’accès à ma collection',
        nl: 'Account aanmaken',
    },
    Email: {
        en: 'Email',
        fr: 'Email',
        nl: 'Email',
    },
    Password: {
        en: 'Password',
        fr: 'Mot de passe',
        nl: 'Wachtwoord',
    },
    'Confirm Password': {
        en: 'Confirm Password',
        fr: 'Confirmer mot de passe',
        nl: 'Wachtwoord bevestigen',
    },
    'Dear collectors': {
        en: 'Dear collectors',
        fr: 'Chers amis collectionneurs,',
        nl: 'Beste verzamelaarsvrienden,',
    },
    Welcome: {
        en: 'Welcome,',
        fr: 'Bienvenue,',
        nl: 'Welkom,',
    },
    'Signup info p1': {
        en: 'We hereby invite you to access and view ',
        fr: 'Nous vous invitons à accéder et à consulter',
        nl: 'Wij nodigen u uit om',
    },
    'your online collection p1': {
        en: 'your collection online*.',
        fr: 'votre collection en ligne*.',
        nl: 'uw collectie online*',
    },
    'your online collection p2': {
        en: '',
        fr: '',
        nl: 'te raadplegen.',
    },
    'Signup info p2': {
        en: 'Note that it has been placed in a highly secured environment (using blockchain technology).',
        fr: 'Celle-ci a été placée dans un environnement hautement sécurisé (via la technologie blockchain).',
        nl: 'Deze bevindt zich in een sterk beveiligde omgeving (via de blockchain technologie).',
    },
    'Signup info p3': {
        en: 'Any changes to the data will be made solely through Eeckman Art & Insurance, your specialized broker.',
        fr: 'Toute modification de données se fera par l\'intermédiaire d\'Eeckman Art & Insurance, votre courtier spécialisé.',
        nl: 'Elke gegevenswijziging zal uitgevoerd worden door Eeckman Art & Insurance, uw gespecialiseerde makelaar.',
    },
    'Attention:': {
        en: 'Warning:',
        fr: 'Attention :',
        nl: 'Opgelet:',
    },
    'Signup info p4': {
        en: 'Your password is unique and strictly confidential. It should not be shared with any third party',
        fr: 'Votre mot de passe est unique et strictement confidentiel. Il ne doit pas être divulgué à des tiers',
        nl: 'Uw wachtwoord is uniek en strikt vertrouwelijk. Deze mag niet aan derden worden verstrekt.',
    },
    contact: {
        en: 'Help and contact:',
        fr: 'Aide et contact :',
        nl: 'Hulp en contact:',
    },
    'Signup info p5': {
        en: '*You will soon be able to manage your collection yourself, in an autonomous manner',
        fr: '*Vous pourrez d\'ici peu gérer de manière totalement autonome votre collection',
        nl: '*U zult binnenkort geheel autonoom uw collectie kunnen beheren',
    },
    'Something went wrong': {
        en: 'Something went wrong. Please try again in few minutes.',
        fr: 'Une erreur s\'est produite. Veuillez réessayer dans quelques minutes.',
        nl: 'Er is iets fout gedaan. Probeer het later opnieuw',
    },
    'A user with this email exists': {
        en: 'A user with this email already exists.',
        fr: 'Il existe déjà un compte sous cette adresse e-mail.',
        nl: 'Er is al een gebruiker met dit e-mailadres',
    },
    'Passwords do not match': {
        en: 'Passwords do not match',
        fr: 'Les mots de passe ne correspondent pas',
        nl: 'De wachtwoorden komen niet overeen',
    },
    'Password should be': {
        en: 'The password should be at least 8 characters long and contain at least 1 number and 1 letter',
        fr: 'Le mot de passe doit contenir au minimum 8 caractères et contenir au moins un chiffre et une lettre',
        nl: 'Het wachtwoord moet minsten 8 karakters lang zijn en ten minste 1 cijfer en een letter bevatten',
    },
};

export default translations;



// WEBPACK FOOTER //
// ./src/translations/translations.js